import 'whatwg-fetch';
import * as constants from '../constants/actions';
import * as endpoint from '../constants/endpoints';
import * as api from '../constants/api';

import {parseJSON, isOk, authReq} from '../utils/request';


/******************************
*******  Synchronous  *********
******************************/

export function userSetUser(user) {
  return {
    type: constants.USER_SET,
    user
  };
}

/******************************
*******  Asynchronous  ********
******************************/

export function userSubmitSupportRequest(supportData) {
	return dispatch => {
		let url = api.URL + endpoint.USERS_SUPPORT;
		return fetch(url, {
		  method: 'post',
		  headers: authReq(api.HEADERS),
		  body: JSON.stringify(supportData)
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}

export function userFetchUser() {
	return dispatch => {
		let url = api.URL + endpoint.USERS_FETCH;
		return fetch(url, {
		  method: 'get',
		  headers: authReq(api.HEADERS),
		})
		.then(parseJSON)
		.then((resp) => {
	    if(isOk(resp.status)) {
	    	return Promise.resolve(resp.data);
	    } else {
	    	return Promise.reject(resp.data);
	    }
	  });
	}
}



// WEBPACK FOOTER //
// ./src/actions/user.jsx